<template>
    <div class="container-fluid">
        <div class="page-header">
            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <div class="page-header-left">
                        <h3>
                            {{ $t('CRMSetting.ManageAssetCategories') }}
                        </h3>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6">
                    <ol class="breadcrumb pull-right">
                        <li class="breadcrumb-item">
                            <router-link to="/dashboard">
                                <i class="fa fa-home"></i>
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active ">{{ $t('CRMSetting.ManageAssetCategories') }}</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header admin-form">
                        <div class="filter-panel mb-0 pb-0 border-0">
                            <div class="listing-option row">
                                <div class="col-xl-5 col-lg-6">
                                    <div class="row my-1">
                                        <div class="form-group col-sm-6 col-md-5 col-lg-5 pe-2 pe-sm-0 mb-0 mt-2 mt-lg-0">
                                            <input class="form-control" type="text" v-model.trim='searchText'
                                                @keyup='updateFilter($event)'
                                                :placeholder="$t('CRMSetting.SearchNameLabel')">
                                        </div>
                                        <div class="form-group col-sm-6 col-md-7 col-lg-7 mb-0 mt-2 mt-lg-0">
                                            <button type="button" class="btn btn-gradient color-4" @click="search()"
                                                :title="$t('CRMSetting.SearchLabel')">
                                                {{ $t('CRMSetting.SearchLabel') }}
                                            </button>
                                            <button type="reset" class="btn ms-2 px-4 btn-danger" @click="reset()"
                                                :title="$t('CRMSetting.ResetLabel')">
                                                <i class="fas fa-redo-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-7 col-lg-6">
                                    <div class="d-flex flex-wrap justify-content-start justify-content-xl-end my-1">
                                        <router-link href="Javascript:;" to="/assetCategory/addassetcategory"
                                            v-if="filters.IsNull(modulePermission) !== null && modulePermission.roleModuleAddFlag">
                                            <button class="btn btn-primary px-4 mx-1" :title="$t('CRMSetting.AddAssetCategory')"
                                                    v-if="fractionedCompanyId != 'E42A359A-D517-483C-8D7D-5353CA886B41'">
                                                {{ $t('CRMSetting.AddAssetCategory') }}
                                            </button>
                                        </router-link>
                                        <button class="btn btn-danger mx-1" :title="$t('CRMSetting.DeleteLabel')"
                                            v-if="filters.IsNull(modulePermission) !== null && modulePermission.roleModuleDeleteFlag"
                                            @click="deleteMultipleAssetCategory">
                                            {{ $t('CRMSetting.DeleteLabel') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body payment-table pt-0" v-if="totalRecords > 0">
                        <DataTable @sort="onSort($event)" stripedRows :paginator="false" :value="data"
                            class="p-datatable-gridlines" :scrollable="true" scrollHeight="700px" :lazy="true" dataKey="Id"
                            v-model:selection="selectedAssetCategory">
                            <Column selectionMode="multiple" class="min-max-width-100 justify-content-center text-center">
                            </Column>
                            <Column
                                :sortable="(col.COLUMN_NAME == 'CompanyAddedStatus' || col.COLUMN_NAME == 'AttributeCount') ? false : true"
                                v-for="col of schema" :field="col.COLUMN_NAME"
                                :header="$filters.dynamicTranslate($t(`CRMSetting.Category${col.COLUMN_NAME}`), `CRMSetting.Category${col.COLUMN_NAME}`, col.DISPLAY_NAME)"
                                :key="col.Id" class="min-max-width-250"
                                :class="{ 'justify-content-center text-center ': (col.COLUMN_NAME == 'IsActive' || col.COLUMN_NAME == 'AttributeCount' || col.COLUMN_NAME == 'CompanyAddedStatus' || col.COLUMN_NAME == 'ImagePath') }">
                                <template #body="action">
                                    <span v-if="col.COLUMN_NAME == 'AttributeCount'">
                                        <a href="Javascript:void(0);" @click="openPopupAttribute(action.data)"
                                            v-if="action.data[col.COLUMN_NAME] != 0">
                                            <span class="text-dark p-2 border rounded bg-white icon-with-info">
                                                <i class="fa fa-building"></i>
                                                <span class="bg-primary">{{ action.data[col.COLUMN_NAME] }}</span>
                                            </span>
                                        </a>

                                        <span class="text-dark p-2 border rounded bg-white icon-with-info"
                                            v-if="action.data[col.COLUMN_NAME] == 0">
                                            <i class="fa fa-building"></i>
                                            <span class="bg-danger">{{ action.data[col.COLUMN_NAME] }}</span>
                                        </span>
                                    </span>

                                    <span v-if="col.COLUMN_NAME == 'Name'">
                                        <a href="Javascript:void(0);" @click="navigate(action.data.Id)"
                                            v-bind:attribute-id="action.data.Id">
                                            {{
                                                action.data[col.COLUMN_NAME]
                                            }}
                                        </a>
                                    </span>
                                    <span v-if="col.COLUMN_NAME == 'ImagePath'">
                                        <div class="text-center">
                                            <img :src="action.data[col.COLUMN_NAME]" alt="img" class="table-img">
                                        </div>
                                    </span>
                                    <span v-if="col.COLUMN_NAME == 'Description'">
                                        <div :title="[action.data.Description]">
                                            <template v-if="calculateLenght(action.data.Description) > 25">
                                                {{ filters.TruncateStr(action.data.Description, 25) }} <a
                                                    @click="OpenDescriptionModel(action.data)" href="javascript:;"> <i class="fa fa-binoculars" aria-hidden="true"></i>
                                                    &raquo;</a>
                                            </template>
                                            <span v-else href="javascript:;">
                                                {{ action.data.Description }}
                                            </span>
                                        </div>

                                    </span>

                                    <span v-if="col.COLUMN_NAME == 'CompanyAddedStatus'"
                                        class="text-center justify-content-center w-100 mx-1">
                                        <a v-if="(action.data[col.COLUMN_NAME] == 'Mapped') && (filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag)"
                                            href="javascript:;" @click="notAdded(action.data)">

                                            <span class="label label-light color-3" :title="$t('CRMSetting.NotAdded')">
                                                {{ $t('CRMSetting.AddedLabel') }}
                                            </span>
                                        </a>
                                        <a v-if="(action.data[col.COLUMN_NAME] == 'SelfAdded') && (filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag)"
                                            href="javascript:;" style="cursor: not-allowed;">
                                            <span class="label label-light color-3" :title="$t('CRMSetting.AddedLabel')">
                                                {{ $t('CRMSetting.AddedLabel') }}
                                            </span>
                                        </a>

                                        <a v-if="(action.data[col.COLUMN_NAME] == 'NotAdded') && (filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag)"
                                            href="javascript:;" @click="added(action.data)">
                                            <span class="label label-light color-5" :title="$t('CRMSetting.ClickToMap')">
                                                {{ $t('CRMSetting.NotAdded') }}
                                            </span>
                                        </a>
                                    </span>
                                    <span v-if="col.COLUMN_NAME == 'IsActive'" class="w-100 mx-1">
                                        <div class="text-center justify-content-center ">
                                            <a v-if="(action.data[col.COLUMN_NAME] == true && action.data['CompanyAddedStatus'] == 'SelfAdded') && (filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag)"
                                                href="javascript:;" @click="disable(action.data)">

                                                <span class="label label-light color-3"
                                                    :title="$t('CRMSetting.ClickToInActiveLabel')">{{
                                                        $t('CRMSetting.ActiveLabel') }}</span>
                                            </a>
                                            <a v-if="(action.data[col.COLUMN_NAME] == true && action.data['CompanyAddedStatus'] == 'SelfAdded') && (filters.IsNull(modulePermission) !== null && !modulePermission.roleModuleUpdateFlag && modulePermission.roleModuleReadFlag)"
                                                href="javascript:;" style="cursor: not-allowed;">
                                                <span class="label label-light color-3"
                                                    :title="$t('CRMSetting.ClickToInActiveLabel')">{{
                                                        $t('CRMSetting.ActiveLabel') }}</span>
                                            </a>
                                            <a v-if="(action.data[col.COLUMN_NAME] == true && (action.data['CompanyAddedStatus'] == 'Mapped' || action.data['CompanyAddedStatus'] == 'NotAdded'))"
                                                href="javascript:;" style="cursor: not-allowed;">
                                                <span class="label label-light color-3"
                                                    :title="$t('CRMSetting.ClickToInActiveLabel')">{{
                                                        $t('CRMSetting.ActiveLabel') }}</span>
                                            </a>
                                            <a v-if="(action.data[col.COLUMN_NAME] == false && action.data['CompanyAddedStatus'] == 'SelfAdded') && (filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag)"
                                                href="javascript:;" @click="enable(action.data)">
                                                <span class="label label-light color-5"
                                                    :title="$t('CRMSetting.ClickToActiveLabel')">{{  $t('CRMSetting.InActiveLabel') }}</span>
                                            </a>
                                            <a v-if="(action.data[col.COLUMN_NAME] == false && (action.data['CompanyAddedStatus'] == 'Mapped' || action.data['CompanyAddedStatus'] == 'NotAdded'))"
                                                href="javascript:;" style="cursor: not-allowed;">
                                                <span class="label label-light color-5"
                                                    :title="$t('CRMSetting.ClickToActiveLabel')">{{
                                                        $t('CRMSetting.InActiveLabel') }}</span>
                                            </a>
                                        </div>
                                    </span>
                                    <span v-if="col.COLUMN_NAME != 'ImagePath' && col.COLUMN_NAME != 'IsActive' && col.COLUMN_NAME != 'Name' && col.COLUMN_NAME != 'CompanyAddedStatus' && col.COLUMN_NAME != 'Description'
                                        && col.COLUMN_NAME != 'AttributeCount'">
                                        {{ action.data[col.COLUMN_NAME] }}
                                    </span>
                                </template>
                            </Column>
                            <Column :header="$t('CRMSetting.EditLabel')" :sortable="false" class="min-max-width-100"
                                headerClass="text-center justify-content-center"
                                bodyClass="text-center justify-content-center"
                                v-if="filters.IsNull(modulePermission) !== null && (modulePermission.roleModuleUpdateFlag)">
                                <template #body="action">
                                    <a href="Javascript:void(0);" @click="navigate(action.data.Id)"
                                        v-if="filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag"
                                        class="p-2 border rounded btn-bg-green2">
                                        <i :title="$t('CRMSetting.ClickToEditLabel')"
                                            class="fas fa-edit"></i>
                                    </a>
                                </template>
                            </Column>
                            <Column :header="$t('CRMSetting.DeleteLabel')" :sortable="false" class="min-max-width-100"
                                headerClass="text-center justify-content-center"
                                bodyClass="text-center justify-content-center"
                                v-if="filters.IsNull(modulePermission) !== null && (modulePermission.roleModuleDeleteFlag)">
                                <template #body="action">

                                    <a href="Javascript:void(0);"
                                        v-if="filters.IsNull(modulePermission) !== null && modulePermission.roleModuleDeleteFlag && userType == 'usertype01' || action.data['CompanyAddedStatus'] == 'SelfAdded'"
                                        @click="deleteAssetCategory(action.data)"
                                        class="p-2 border rounded btn-bg-red">
                                        <i :title="$t('CRMSetting.ClickToDelete')" class="fas fa-eraser"></i>
                                    </a>
                                </template>
                            </Column>
                            <template #footer>
                                <div class="row">
                                    <Paginator :template="paginatorTemplate.value" :rows="pageSize"
                                        :totalRecords="totalRecords" :rowsPerPageOptions="pageSizeList"
                                        @page="onPage($event)">
                                        <template #start>
                                            <div class="row">
                                                {{ $t('CRMSetting.TotalRecord') }}: {{ totalRecords }} {{ RowsPerPageDropdown }}
                                            </div>
                                        </template>

                                    </Paginator>
                                </div>
                            </template>

                        </DataTable>
                    </div>
                    <div class="card-body payment-table pt-2" v-else>
                        <div class="no-record-found"><span>{{ $t('CRMSetting.NoRecordFoundLabel') }}</span></div>
                    </div>
                </div>
            </div>

            <Loading v-model:active="isLoading">
            </Loading>

            <div v-if="DescriptionPopup" class="modal-container ">
                <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $t('CRMSetting.Description') }} : {{ DescriptionPopuptitle }} </h5>

                            <a class="modal-close" @click="CloseDescriptionPopup()"><i class="fa fa-times"></i></a>
                        </div>
                        <div class="modal-body">

                            <div style="word-wrap: break-word;">
                                {{ DescriptionPopupvalue }}
                            </div>


                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-pill btn-danger" @click="CloseDescriptionPopup()">{{
                                $t('CRMSetting.CloseLabel') }}</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <CategoryAttributeListShared v-if="AttributeListPopup" :assetCategoryId="primaryIdAssetCategory"
        @closeOrOpen="closeAttributeListPopup">
    </CategoryAttributeListShared>
</template>
<script>
import { ref, onMounted, getCurrentInstance } from "vue";
import { createConfirmDialog } from "vuejs-confirm-dialog";
import SimpleDialog from "@/views/shared/SimpleDialog.vue";
import { createToaster } from "@meforma/vue-toaster";
import AssetCategoryService from "@/service/crmservice/assetcategoryservice";
import router from '../../../router/index.js'
import common from '@/views/shared/common/commonuses.js'
import CommonService from '@/service/crmservice/commonService'
import { callExpression, returnStatement } from '@babel/types';
//Components
import CategoryAttributeListShared from "../assetcategoryattribute/categoryattributelistshared.vue";
import { useI18n } from 'vue-i18n';

export default {
    name: 'assestcategorylist',
    components: {
        CategoryAttributeListShared
    },
    emits: ['closeOrOpen'],
    setup(props) {
        const { t } = useI18n();
        const toaster = createToaster({ position: 'top-right' });
        const thisApp = getCurrentInstance();
        const filters = thisApp.appContext.config.globalProperties.$filters;
        const paginatorTemplate = filters.PaginatorTemplate(0, 10);
        const commonuse = ref(common);
        const isLoading = ref(false);
        const userId = ref(null);
        const companyId = ref(null);
        const schema = ref([]);
        const data = ref([]);
        const InActiveSuperAdminCategory = ref([]);
        const assetCategoryService = ref(new AssetCategoryService());
        const totalRecords = ref(0);
        const pageSize = ref(10);
        const pageNumber = ref(1);
        const pageSizeList = ref([]);
        const selectedAssetCategory = ref([]);
        const deleteIds = ref([]);
        const sortBy = ref('desc');
        const sortExp = ref('CreatedOn');
        const moduleName = ref('6001');
        const subModuleName = ref('6001');
        const langCode = ref('EN');
        const isExport = ref(false);
        const searchText = ref(null);
        const commonService = ref(new CommonService());
        const modulePermission = ref(null);
        const viewPortId = ref(null);
        const searchFilter = ref(null);
        const widgetType = ref(null);
        const recordFilter = ref(null);
        const teamId = ref(null);
        const teamMemberId = ref(null);
        const isAllRecords = ref(false);
        const deleteObj = ref({});
        const userType = ref(null);
        const imageLink = ref(require("../../../assets/images/AssetDefault.png"));
        const DescriptionPopup = ref(false);
        const DescriptionPopupvalue = ref(null);
        const DescriptionPopuptitle = ref(null);
        const IpAddress = ref(null);
        const AttributeListPopup = ref(false);
        const primaryIdAssetCategory = ref(null);
        const fractionedCompanyId = ref(localStorage.getItem('companyId'));
        const calculateLenght = (value) => {
            return value != null ? value.length : 0
        }
        const GetIpAddress = async () => {
            IpAddress.value = await commonuse.value.GetIPAddress()
        }
        const OpenDescriptionModel = (data) => {
            DescriptionPopup.value = true;
            DescriptionPopupvalue.value = data.Description;
            DescriptionPopuptitle.value = data.Name;
        }

        const CloseDescriptionPopup = () => {
            DescriptionPopup.value = false;
        }

        const GetPageSizeList = () => {
            commonService.value.GetPageSizeList().then(response => {
                if (response.data != null) {
                    pageSizeList.value = response.data.map(item => { return parseInt(item.text) });
                }
            }).catch((error) => {
            });
        }
        const added = (data) => {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: t("CRMSetting.AreYouSureYouWantToMapCategory") + ` "${data.Name}"?`,
                header: t("CRMSetting.MapCatergory"),
                cancel: t("CRMSetting.CancelLabel"),
                confirm: t("CRMSetting.Ok"),
            });
            onConfirm(() => {
                isLoading.value = true;
                assetCategoryService.value.MapAttributeToCompany(data.Id, userId.value, companyId.value, data.CompanyAddedStatus == 'Mapped' ? true : false).then(r => {
                    toaster.success(t("CRMSetting.Category") + ` "${data.Name}" ` + t("CRMSetting.HasBeenMappedSuccessfully"));
                    getAssetCategoryListing();
                    isLoading.value = false;
                }, error => {
                    isLoading.value = false;
                    getAssetCategoryListing();
                    toaster.error(t('CRMSetting.Somethingwentwrong'));
                });
            });
            reveal(() => {
                getAssetCategoryListing();
            });
        }

        const notAdded = (data) => {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: t("CRMSetting.AreYouSureYouWantToUnmapAssetCategory") + ` "${data.Name}"?`,
                header: t("CRMSetting.UnMapCategory"),
                cancel: t("CRMSetting.CancelLabel"),
                confirm: t("CRMSetting.Ok"),
            });
            onConfirm(() => {
                if (data.AssetCount > 0) {
                    isLoading.value = false;
                    toaster.error(t("CRMSetting.Category") + ` "${data.Name}" ` + t("CRMSetting.CannotBeUnmapBecauseItIsBeingUsedInAsset"));
                } else {
                    isLoading.value = true;
                    assetCategoryService.value.MapAttributeToCompany(data.Id, userId.value, companyId.value, data.CompanyAddedStatus == 'Mapped' ? true : false).then(r => {
                        toaster.success(t("CRMSetting.Category") + ` "${data.Name}" ` + t("CRMSetting.HasBeenUnmappedSuccessfully"));
                        getAssetCategoryListing();
                        isLoading.value = false;
                    }, error => {
                        getAssetCategoryListing();
                        isLoading.value = false;
                        console.warn(error);
                        toaster.error(t('CRMSetting.Somethingwentwrong'));
                    }
                    );

                }


            });
            reveal(() => {
                getAssetCategoryListing();

            });
        }
        const enable = (data) => {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: t("CRMSetting.AreYouSureYouWantToActive") + ' ' + t("CRMSetting.Category") + ` "${data.Name}"?`,
                header: t("CRMSetting.ActiveLabel") + ' ' + t("CRMSetting.Category"),
                cancel: t("CRMSetting.CancelLabel"),
                confirm: t("CRMSetting.Ok"),
            });
            onConfirm(() => {
                if (data.IsActive == false) {
                    data.IsActive = true;
                } else { data.IsActive = false; }
                isLoading.value = true;
                assetCategoryService.value.ActiveInactiveAssetCategory(data.Id, data.IsActive, userId.value, companyId.value).then(r => {
                    toaster.success(t("CRMSetting.Category") + ` "${data.Name}" ` + t('CRMSetting.HasBeenActivatedSuccessfully'));
                    setTimeout(toaster.clear, 3000)
                    getAssetCategoryListing();
                    isLoading.value = false;
                }, error => {
                    isLoading.value = false;
                    getAssetCategoryListing();
                    toaster.error(t('CRMSetting.Somethingwentwrong'));
                });
            });
            reveal(() => {
                getAssetCategoryListing();
            });
        }
        const disable = (data) => {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: t('CRMSetting.AreYouSureYouWantToInActive') + ' ' + t('CRMSetting.Category') +` "${data.Name}"?`,
                header: t("CRMSetting.InActiveLabel") + ' ' + t("CRMSetting.Category"),
                cancel: t("CRMSetting.CancelLabel"),
                confirm: t("CRMSetting.Ok"),
            });
            onConfirm(() => {

                if (data.AssetCount > 0) {
                    isLoading.value = false;
                    toaster.error(t("CRMSetting.Category") + ` "${data.Name}" ` + t("CRMSetting.CannotBeInActiveBecauseItIsBeingUsedInAsset"));
                } else {
                    if (data.IsActive == false) {
                        data.IsActive = true;
                    } else { data.IsActive = false; }
                    isLoading.value = true;
                    assetCategoryService.value.ActiveInactiveAssetCategory(data.Id, data.IsActive, userId.value, companyId.value).then(r => {
                        //toaster.error('Something went wrong');
                        toaster.success(t("CRMSetting.Category") + ` "${data.Name}"` +' ' +  t('CRMSetting.HasBeenInActivatedSuccessfully'));
                        setTimeout(toaster.clear, 3000)
                        getAssetCategoryListing();
                        isLoading.value = false;
                    }, error => {
                        getAssetCategoryListing();
                        isLoading.value = false;
                        console.warn(error);
                        toaster.error(t('CRMSetting.Somethingwentwrong'));
                    }

                    );

                }

            });
            reveal(() => {
                getAssetCategoryListing();

            });
        }
        const updateFilter = (event) => {
            let keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode === 13 || keycode === '13') {
                search();
            }
        }
        const search = async () => {
            pageNumber.value = 1;
            setSearchFilter();
            getAssetCategoryListing();
        }
        const reset = async () => {
            searchText.value = null;
            searchFilter.value = null;
            pageNumber.value = 1;
            pageSize.value = 10;
            getAssetCategoryListing();
        }
        const setSearchFilter = () => {
            searchFilter.value = "Name Like '%" + searchText.value + "%'";
        }
        const onSort = (event) => {
            sortExp.value = event.sortField;
            if (event.sortField == 'IsActive') {
                sortBy.value = event.sortOrder == '1' ? 'desc' : 'asc';
            } else {
                sortBy.value = event.sortOrder == '1' ? 'asc' : 'desc';
            }
            getAssetCategoryListing();
        }
        const onPage = (event) => {
            pageNumber.value = event.page == 0 ? 1 : event.page + 1;
            pageSize.value = event.rows;
            getAssetCategoryListing();
        }
        const getUserInfo = () => {
            userId.value = localStorage.getItem("userId");
            companyId.value = localStorage.getItem("companyId");
        }
        const navigate = function (id) {
            if (id != undefined && id != "")
                router.push({ path: '/assetcategory/editassetcategory/' + id })
        }
        const getModulePermissions = () => {
            modulePermission.value = commonuse.value.getPermission(moduleName.value);
            userType.value = JSON.parse(localStorage.getItem("userinfo")).data.userType;
        }
        const getAssetCategoryListing = () => {
            isLoading.value = true;

            assetCategoryService.value.getAssetCategoryListing({
                VIEWER_ID: userId.value, COMPANY_ID: companyId.value, SORT_BY: sortBy.value, SORT_EXP: sortExp.value, PAGESIZE: pageSize.value,
                PAGENUMBER: pageNumber.value, LANG_CODE: langCode.value, IS_EXPORT: isExport.value, SEARCH_CONDITION: searchFilter.value, moduleName: moduleName.value,
                subModuleName: subModuleName.value, viewPortId: viewPortId.value, searchFilter: searchFilter.value, widgetType: widgetType.value, recordFilter: recordFilter.value,
                teamId: teamId.value, teamMemberId: teamMemberId.value, isAllRecords: isAllRecords.value,
            }).then(result => {
                if (result.data.statusCode == 200) {
                    let d = JSON.parse(result.data.result);
                    let show = companyAddedStatusShow();
                    if (!show) {
                        d.Schema = d.Schema.filter(x => x.COLUMN_NAME != 'CompanyAddedStatus');
                    }
                    d.Data.forEach((x) => {
                        x.ImagePath = x.ImagePath == null || x.ImagePath == '' ? imageLink.value : x.ImagePath;
                    })
                    schema.value = d.Schema.filter(x => x.COLUMN_NAME != 'CreatedOn');
                    if (schema.value) {
                        schema.value.forEach(p => {
                            if (p.COLUMN_NAME == 'IsActive') {
                                p.DISPLAY_NAME = 'Status'
                            }
                        })
                    }
                    data.value = [];
                    d.Data.forEach((item) => {
                        if (item.CompanyAddedStatus == 'NotAdded' && item.IsActive == false) {
                            InActiveSuperAdminCategory.value.push(item);
                        } else {
                            data.value.push(item)
                        }
                    })

                    if (d.Data.length > 0) {
                        totalRecords.value = d.Data[0].TotalRecord;
                    } else {
                        totalRecords.value = 0;
                    }
                    paginatorTemplate.value = filters.PaginatorTemplate(totalRecords.value, pageSize.value);

                } else {
                    toaster.error(result.data.responseMessage);
                }
                isLoading.value = false;
            }, error => {
                console.warn(error);
                toaster.error(t('CRMSetting.Somethingwentwrong'));
                isLoading.value = false
            })
        }
        const companyAddedStatusShow = () => {
            if (userType.value != 'usertype01') {
                if (userType.value == 'usertype02' || userType.value == 'usertype06') {
                    return true
                }
            }
            return false
        }
        const deleteAssetCategory = (event) => {
            if (event.AssetCount == 0 && event.mapCount == 0) {
                const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                    question: t('CRMSetting.DeleteMsg') + ' ' + t("CRMSetting.Category") + ` "${event.Name}"?`,
                    header: t("CRMSetting.DeleteLabel") + ' ' + t("CRMSetting.Category"),
                    cancel: t("CRMSetting.CancelLabel"),
                    confirm: t("CRMSetting.Ok"),
                });
                onConfirm(async () => {
                    isLoading.value = true;
                    deleteObj.value = null;
                    selectedAssetCategory.value = [];
                    selectedAssetCategory.value.push(event);
                    deleteObj.value = {
                        companyId: companyId.value,
                        userId: userId.value,
                        primaryKeys: selectedAssetCategory.value,
                        ipAddress: IpAddress.value
                    }
                    await assetCategoryService.value.deleteAssetCategory(deleteObj.value).then(r => {
                        toaster.success(t("CRMSetting.Category") + ` "${event.Name}" ` + t('CRMSetting.hasbeendeletedsuccessfully'));
                        getAssetCategoryListing();
                        isLoading.value = false;
                    }, error => {
                        getAssetCategoryListing();
                        console.warn(error);
                        toaster.error(t('CRMSetting.Somethingwentwrong'));
                        isLoading.value = false
                    });
                });
                reveal(() => {
                    console.log("reveal")
                });
            } else {
                if (userType.value == "usertype01") {
                    toaster.error(t("CRMSetting.Category") + ` "${event.Name}" ` + t("CRMSetting.CannotBeDeleteBecauseItIsMappedByOtherCompanies"));
                } else {
                    toaster.error(t("CRMSetting.Category") + ` "${event.Name}" ` + t("CRMSetting.CannotBeDeleteBecauseItIsBeingUsedInAsset"));
                }

            }

        }

        const deleteMultipleAssetCategory = () => {
            if (selectedAssetCategory.value.length > 0) {
                const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                    question: t('CRMSetting.AreYouSureyouWantToDeleteSelected') +' ' + t('CRMSetting.Category') + "(s)?",
                    header: t('CRMSetting.DeleteLabel') + t('CRMSetting.Category') + "(s)",
                    cancel: t("CRMSetting.CancelLabel"),
                    confirm: t("CRMSetting.Ok"),
                });
                onConfirm(async () => {
                    isLoading.value = true;
                    deleteObj.value = null;
                    deleteObj.value = {
                        companyId: companyId.value,
                        userId: userId.value,
                        primaryKeys: selectedAssetCategory.value,
                        ipAddress: IpAddress.value
                    }
                    await assetCategoryService.value.deleteAssetCategory(deleteObj.value).then(r => {
                        toaster.success(t('CRMSetting.Selected') + ' ' + t('CRMSetting.Category') + '(s) ' + t('CRMSetting.hasbeendeletedsuccessfully'));
                        getAssetCategoryListing();
                        isLoading.value = false;
                    }, error => {
                        getAssetCategoryListing();
                        console.warn(error);
                        toaster.error(t('CRMSetting.Somethingwentwrong'));
                        isLoading.value = false;
                    });
                });
                reveal(() => {
                    console.log("reveal")
                });
            } else {
                toaster.error(t('CRMSetting.PleaseSelectAtLeastOneAssetCategoryBeforeDelete'));
            }

        }

        const openPopupAttribute = (data) => {
            primaryIdAssetCategory.value = data.Id;
            AttributeListPopup.value = true;
        }
        const closeAttributeListPopup = (event) => {
            primaryIdAssetCategory.value = null;
            AttributeListPopup.value = false;
        };

        onMounted(() => {
            getUserInfo();
            GetIpAddress();
            GetPageSizeList()
            getModulePermissions();
            getAssetCategoryListing();
        });

        return {
            schema,
            data,
            assetCategoryService,
            totalRecords,
            pageSize,
            pageNumber,
            pageSizeList,
            sortBy,
            sortExp,
            selectedAssetCategory,
            isLoading,
            searchText,
            paginatorTemplate,
            modulePermission,
            filters,
            userType,
            fractionedCompanyId,
            DescriptionPopup,
            DescriptionPopupvalue,
            DescriptionPopuptitle,
            AttributeListPopup,
            primaryIdAssetCategory,
            calculateLenght,
            notAdded,
            added,
            enable,
            disable,
            updateFilter,
            GetPageSizeList,
            reset,
            search,
            getAssetCategoryListing,
            onPage,
            onSort,
            navigate,
            deleteAssetCategory,
            deleteMultipleAssetCategory,
            CloseDescriptionPopup,
            OpenDescriptionModel,
            openPopupAttribute,
            closeAttributeListPopup
        }

    }
}
</script>
<style>
.wrap-text-custom {
    display: inline-block !important;
    width: 240px !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap;
}
</style>